
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { getLineListByPage } from "@/api/service";
import { LogHelper } from "@/common/LogHelper";

@Component({
  name: "LineListcodename",
  components: {
    // SingleStatistical,
    // Breadcrumb,
    // Hamburger,
  },
  props: {
    lineListDialogShowFlag: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    lineListDialogShowFlag(newone, oldone) {
      if (newone) {
        this.lineCodeNameDialogFormVisible = true;
        try {
          this.findlinecodename();
        } catch (error) {
          LogHelper.Error("lineListDialogShowFlag失败");
          LogHelper.Error(error);
        }
      }
    },
  },
})
export default class extends Vue {
  public selectElementContents(el) {
    //失去焦点，获取焦点
    // el.blur();
    el.focus();
  }
  public openDialog(formName) {
    this.$nextTick(function () {
      this.selectElementContents(document.getElementById("input_linecodename"));
    });
  }
  // private registedObj1 = null;
  private lineCodeNameCurrentPage = 1;
  private lineCodeNameCurrentRow = null;
  private lineCodeNamePagination = 100;
  private lineCodeNameDialogFormVisible = false;
  private lineCodeNameForm = {
    linecodename: "",
  };
  private tableDatalinecodename = [];

  private linecodenameDialogFormOK(flag) {
    LogHelper.Console("|FUNC|linecodenameDialogFormOK:" + flag);

    if (flag) {
      //接口查询
      if (this.lineCodeNameCurrentRow != null) {
        this.$emit("line-list-code-name", this.lineCodeNameCurrentRow);
      } else {
        LogHelper.Console("|FUNC|linecodenameDialogFormOK:" + "未选择线路");
        return;
      }
    } else {
      this.$emit("line-list-code-name", null); //返回空对象
    }
    this.lineCodeNameDialogFormVisible = false;
    this.lineCodeNameForm.linecodename = "";
    this.lineCodeNameCurrentPage = 1;
  }

  private tablehandleCurrentChangeLineCodeName(val) {
    LogHelper.Console("|FUNC|tablehandleCurrentChangeLineCodeName");
    LogHelper.Console(val);
    this.lineCodeNameCurrentRow = val;
  }

  private doubleClickSelectLineCodeName(row) {
    LogHelper.Console("|FUNC|doubleClickSelectLineCodeName");
    LogHelper.Console(row);
    this.lineCodeNameDialogFormVisible = false;
    this.$emit("line-list-code-name", row);
    this.lineCodeNameForm.linecodename = "";
    this.lineCodeNameCurrentPage = 1;
  }

  private searchLineCodeName() {
    LogHelper.Console("|FUNC|searchLineCodeName");
    if (typeof (obj_HttpRequest_Core) == "undefined") {
      // obj_Common.getLineListByPage(
      //   10,
      //   1,
      //   this.lineCodeNameForm.linecodename,
      //   this.initline
      // );
    } else {
      let responseStr = this.GetLineListByPage(
        10,
        1,
        this.lineCodeNameForm.linecodename
      );
      this.initline(responseStr);
    }

    this.lineCodeNameCurrentPage = 1;
  }

  private handleCurrentChangeLineCodeName(val) {
    LogHelper.Console("|FUNC|handleCurrentChangeLineCodeName");
    if (typeof (obj_HttpRequest_Core) == "undefined") {
      // obj_Common.getLineListByPage(
      //   10,
      //   val,
      //   this.lineCodeNameForm.linecodename,
      //   this.initline
      // );
    } else {
      let responseStr = this.GetLineListByPage(
        10,
        val,
        this.lineCodeNameForm.linecodename
      );
      this.initline(responseStr);
    }
  }

  public findlinecodename() {
    LogHelper.Console("|FUNC|findlinecodename");
    this.lineCodeNameDialogFormVisible = true;
    let aaa = typeof (obj_HttpRequest_Core);
    if (typeof (obj_HttpRequest_Core) == "undefined") {
      // obj_Common.getLineListByPage(
      //   10,
      //   1,
      //   this.lineCodeNameForm.linecodename,
      //   this.initline
      // );
    } else {
      let responseStr = this.GetLineListByPage(
        10,
        1,
        this.lineCodeNameForm.linecodename
      );
      this.initline(responseStr);
    }
  }
  private GetLineListByPage(pageSize, current, filter) {
    let body = {
      queryValue: filter, //网点
      queryType: "16",
      viewType: "1",
      extend1: current.toString(), //当前页
      extend2: pageSize.toString(), //页大小
      extend3: "", //过滤字段
    };
    let job = {
      devMac: "00-00-00-00-00-00",
      devType: "0",
      body: body,
    };


    var result = getLineListByPage(JSON.stringify(job));
    if (result != null && result.length > 0) {
      try {
        return result;
      } catch (ex) {
        LogHelper.Error("获取线路失败：" + ex);
      }
    } else {
      return {};
    }
  }
  //初始化线路数据
  private initline(datas): void {
    LogHelper.Console("|FUNC|initline");
    var jsonobj = JSON.parse(datas);
    if (jsonobj.respcode == "000") {
      var alllines = jsonobj.data.busiData.records;
      LogHelper.Console(alllines);
      this.tableDatalinecodename = alllines;
      this.lineCodeNamePagination = jsonobj.data.busiData.total;
    } else {
      LogHelper.Console(jsonobj);
    }
  }
}
